export default __webpack_public_path__ + "static/media/lapiz.11514e30.png";